var _path, _path2, _path3, _path4, _circle, _path5, _g, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgForceUpgradeBackground = function SvgForceUpgradeBackground(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 375,
    height: 812,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M0 0h375v812H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#824600",
    d: "M216.493 259.098c21.869 21.869 21.869 57.327 0 79.196-5.168 5.167-11.094 9.112-17.421 11.838l-20.763-52.853-52.85-20.764c2.725-6.325 6.671-12.25 11.838-17.417 21.869-21.869 57.326-21.869 79.196 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M276.909 198.672c1.823 32.898-9.829 66.403-34.961 91.535-15.455 15.456-34.079 25.813-53.78 31.074l-33.862-33.863c5.215-19.533 15.442-38.005 30.679-53.383l.797-.798c25.085-24.854 58.405-36.376 91.127-34.565"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a803",
    d: "M188.17 321.279c-4.648 1.242-9.355 2.2-14.096 2.874l-22.641-22.64c.674-4.741 1.632-9.449 2.874-14.098z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 239.12,
    cy: 239.298,
    r: 14,
    fill: "#824600",
    stroke: "#e8a803",
    strokeWidth: 8,
    transform: "rotate(45 239.12 239.298)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "c",
    width: 244,
    height: 245,
    x: -83,
    y: 314,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M133.353 318.663c6.675-5.33 16.289-4.793 22.329 1.247 6.039 6.04 6.576 15.654 1.246 22.328L-4.72833 544.691c-13.39657 16.777-38.40647 18.174-53.58787 2.993l-13.7761-13.776c-15.1813-15.182-13.7846-40.192 2.9927-53.588z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M128.913 323.108c6.675-5.329 16.288-4.792 22.328 1.247 6.04 6.04 6.577 15.654 1.247 22.329L-9.16876 549.136c-13.39654 16.778-38.40654 18.174-53.58784 2.993l-13.7761-13.776c-15.1814-15.181-13.7846-40.191 2.9927-53.588z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e8a803",
    d: "M133.555 329.938c3.398-2.958 8.506-2.781 11.691.405 3.186 3.185 3.363 8.293.405 11.691L-38.2095 553.291c-10.6497 12.236-29.4378 12.887-40.9084 1.416-11.4705-11.47-10.8199-30.259 1.4166-40.908z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#824600",
    d: "M132.529 337.2c1.636-1.519 4.181-1.472 5.759.107 1.579 1.578 1.626 4.123.107 5.759L-69.0919 566.479c-5.9472 6.403-16.0222 6.589-22.2018.41-6.1796-6.18-5.9935-16.255.4101-22.202z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M304.443 412.201c-.261-2.737-2.406-4.917-5.139-5.22l-3.308-.368c-.567-.063-.996-.542-.996-1.113s.429-1.05.996-1.113l3.308-.368c2.733-.303 4.878-2.483 5.139-5.22L304.9 394c.054-.567.53-1 1.1-1s1.046.433 1.1 1l.457 4.799c.261 2.737 2.406 4.917 5.139 5.22l3.308.368c.567.063.996.542.996 1.113s-.429 1.05-.996 1.113l-3.308.368c-2.733.303-4.878 2.483-5.139 5.22L307.1 417c-.054.567-.53 1-1.1 1s-1.046-.433-1.1-1zM121.443 92.2009c-.261-2.7373-2.406-4.9164-5.139-5.2203l-3.308-.3677c-.567-.063-.996-.5424-.996-1.1129s.429-1.0499.996-1.1129l3.308-.3677c2.733-.3039 4.878-2.483 5.139-5.2203l.457-4.7987c.054-.5672.53-1.0004 1.1-1.0004s1.046.4332 1.1 1.0004l.457 4.7987c.261 2.7373 2.406 4.9164 5.139 5.2203l3.308.3677c.567.063.996.5424.996 1.1129s-.429 1.0499-.996 1.1129l-3.308.3677c-2.733.3039-4.878 2.483-5.139 5.2203l-.457 4.7987c-.054.5672-.53 1.0004-1.1 1.0004s-1.046-.4332-1.1-1.0004zM131.028 523.816c-.257-2.606-2.308-4.674-4.912-4.953l-3.199-.343c-.522-.056-.917-.496-.917-1.02s.395-.964.917-1.02l3.199-.343c2.604-.279 4.655-2.347 4.912-4.953l.418-4.229c.054-.542.51-.955 1.054-.955s1 .413 1.054.955l.418 4.229c.257 2.606 2.308 4.674 4.912 4.953l3.199.343c.522.056.917.496.917 1.02s-.395.964-.917 1.02l-3.199.343c-2.604.279-4.655 2.347-4.912 4.953l-.418 4.229c-.054.542-.51.955-1.054.955s-1-.413-1.054-.955zM305.028 702.816c-.257-2.606-2.308-4.674-4.912-4.953l-3.199-.343c-.522-.056-.917-.496-.917-1.02s.395-.964.917-1.02l3.199-.343c2.604-.279 4.655-2.347 4.912-4.953l.418-4.229c.054-.542.51-.955 1.054-.955s1 .413 1.054.955l.418 4.229c.257 2.606 2.308 4.674 4.912 4.953l3.199.343c.522.056.917.496.917 1.02s-.395.964-.917 1.02l-3.199.343c-2.604.279-4.655 2.347-4.912 4.953l-.418 4.229c-.054.542-.51.955-1.054.955s-1-.413-1.054-.955zM42.025 227.679c-.1752-1.734-1.5438-3.108-3.2779-3.29l-2.1491-.225c-.3399-.036-.598-.322-.598-.664s.2581-.628.598-.664l2.1491-.225c1.7341-.182 3.1027-1.556 3.2779-3.29l.2712-2.685c.0365-.361.3407-.636.7038-.636s.6673.275.7038.636l.2712 2.685c.1752 1.734 1.5438 3.108 3.2779 3.29l2.1491.225c.3399.036.598.322.598.664s-.2581.628-.598.664l-2.1491.225c-1.7341.182-3.1027 1.556-3.2779 3.29l-.2712 2.685c-.0365.361-.3407.636-.7038.636s-.6673-.275-.7038-.636z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 4,
    d: "m238 101-71 71M205 768l-71 71M380 426l-42 42M36 676l-42 42M206-10l-47 47M21 141l-29 29M228 439l-29 29M270 622l-46 52"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "m375 86-29 29"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0,
    x2: 618.159,
    y1: 0,
    y2: 285.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe687"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc14f"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h375v812H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgForceUpgradeBackground);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "force-upgrade-background.18a59b995f354625be41bfe9d9fe3de7.svg";